import { ScrollFadeIn } from "@/components/effects/ScrollFadeIn";

const steps = [
  {
    tag: "01",
    title: "Build",
    description: "We design and develop your MVP fast—so you can validate before investing big.",
  },
  {
    tag: "02",
    title: "Iterate",
    description: "Bi-weekly sprints to ship features, improve UX, and scale efficiently.",
  },
  {
    tag: "03",
    title: "Scale",
    description: "From 1 to 1,000,000 users—we handle infrastructure and performance.",
  },
  {
    tag: "04",
    title: "Launch",
    description: "We manage domains, SSL, hosting, and deployments. You never touch a server.",
  },
];

const Process = () => {
  return (
    <section id="process" className="py-28 px-4 relative">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-secondary/20 to-transparent" />
      
      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <ScrollFadeIn>
          <div className="text-center mb-20">
            <h2 className="text-4xl sm:text-5xl font-bold mb-5 font-heading">
              How we <span className="text-gradient-indigo">work</span>
            </h2>
            <p className="text-muted-foreground max-w-lg mx-auto">
              We simplify complex builds into fast, focused sprints.
            </p>
          </div>
        </ScrollFadeIn>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line - hidden on mobile, visible on md+ */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-primary/50 via-primary to-primary/50 -translate-x-1/2" />

          {/* Timeline steps */}
          <div className="space-y-12 md:space-y-0">
            {steps.map((step, index) => (
              <ScrollFadeIn key={index} delay={index * 150}>
                <div className={`relative flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-0 ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                } ${index !== steps.length - 1 ? "md:pb-20" : ""}`}>
                  
                  {/* Content card */}
                  <div className={`w-full md:w-[calc(50%-3rem)] ${
                    index % 2 === 0 ? "md:pr-0 md:text-right" : "md:pl-0 md:text-left"
                  }`}>
                    <div className="glass-card rounded-2xl p-6 glow-border group hover:border-primary/30 transition-all duration-500">
                      <span className="text-xs font-mono font-semibold text-primary mb-2 block tracking-widest uppercase">
                        Step {step.tag}
                      </span>
                      <h3 className="text-xl font-bold mb-2 font-heading">{step.title}</h3>
                      <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
                    </div>
                  </div>

                  {/* Timeline node */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background border-2 border-primary flex items-center justify-center shadow-lg shadow-primary/20">
                      <span className="text-sm font-bold font-mono text-primary">{step.tag}</span>
                    </div>
                  </div>

                  {/* Mobile node */}
                  <div className="md:hidden flex items-center justify-center order-first">
                    <div className="w-10 h-10 rounded-full bg-background border-2 border-primary flex items-center justify-center shadow-lg shadow-primary/20">
                      <span className="text-xs font-bold font-mono text-primary">{step.tag}</span>
                    </div>
                  </div>

                  {/* Spacer for opposite side */}
                  <div className="hidden md:block w-[calc(50%-3rem)]" />
                </div>
              </ScrollFadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
